import { Typography, useMediaQuery, useTheme } from "@mui/material";
import NOTFOUND from "../assets/notFound.jpg";

function NotFound(): JSX.Element {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div
      style={{
        backgroundColor: "white",
        color: "grey",
        textAlign: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img alt="404" src={NOTFOUND} width={isSmallScreen ? "80%" : "50%"} />
      <div className="displayCenter">
        <div>
          <Typography mb={2} variant={isSmallScreen ? "h3" : "h4"}>
            Page Not Found
          </Typography>
          <Typography variant="body1">
            Resource Requested cannot be found on the server!
          </Typography>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
